module.exports = __webpack_public_path__ + "img/eva-er-ikke-laengere-3.6896fc42.png";